import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import structure_urnii from "../../../images/structure/structure_urnii.png";

export default function Structure() {
  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="contacts__title history__title structure__title">
        Структура института
      </h1>
      <img
        alt="Структура института"
        className="history__image structure__image"
        src={structure_urnii}
      ></img>

      <a
        href="/files/structure/structura_NII.pdf"
        download
        class="structure__download-link"
      >
        📥 Скачать PDF
      </a>
    </section>
  );
}
